export enum EPixelEventName {
  PageIn = 'page_in',
  BottomCtaClick = 'bottom_cta_click',
  TopCtaClick = 'top_cta_click',
  SelectPharmacy = 'select_pharmacy',
}
